import styled, { css } from 'styled-components'

import NewTagStarIcon from '../../../../assets/icons/filter-icons/star.svg'
import ChevronDownIcon from '../../../../assets/icons/grey-chevron-down.svg'
import { StyledSvgComponent } from '../../../../types/svg'

export const Container = styled.div(
    ({ theme }) => css`
        padding: ${theme.spacing.small} 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        box-sizing: border-box;
    `,
)

export const ChevronDown = styled(ChevronDownIcon as StyledSvgComponent)`
    height: 2rem;
    width: 2rem;
`

export const ChevronUp = styled(ChevronDown)`
    transform: rotate(180deg);
`

export const NewTagContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        position: relative;
        margin-left: ${theme.spacing.xxSmall};
        background-color: ${theme.colors.tfwRedOpacity08};
        border-radius: ${theme.typography.border.radius.xSmall};
        padding: ${theme.spacing.xxxSmall} ${theme.spacing.xSmall};
        letter-spacing: 0.025rem;
        text-transform: uppercase;
        color: ${theme.colors.tfwRed};
        font-size: 0.5625rem;
        line-height: ${theme.typography.font.size.medium};
    `,
)

export const NewTagIcon = styled(NewTagStarIcon as StyledSvgComponent)`
    position: absolute;
    top: 0;
    right: 0;
    height: ${({ theme }) => theme.spacing.xSmall};
    width: ${({ theme }) => theme.spacing.xSmall};
`
export const Text = styled.div(
    ({ theme }) => css`
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.medium} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
        font-feature-settings: 'ordn' on;
    `,
)
